import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const patientService = {
  getList: (data) => api.post(API_PATHS.PATIENT_LIST, data),
  getDetails: (data) => api.post(API_PATHS.PATIENT_DETAILS, data),
  getOldDues: (data) => api.post(API_PATHS.PATIENT_OLD_DUES, data),
  add: (formData) => api.upload(API_PATHS.PATIENT_ADD, formData),
  getPaymentHistory: (data) => api.post(API_PATHS.PATIENT_PAYMENT_HISTORY, data),
  getSessions: (data) => api.post(API_PATHS.PATIENT_SESSION, data),
  deactivate: (data) => api.post(API_PATHS.PATIENT_DEACTIVATE, data),
  uploadPrescription: (formData) => api.upload(API_PATHS.PRESCRIPTION_UPLOAD, formData),
  getPrescriptions: (data) => api.post(API_PATHS.PRESCRIPTION_LIST, data),
  deletePrescription: (data) => api.post(API_PATHS.PRESCRIPTION_DELETE, data),
  exportCsv: () => api.downloadCsv(API_PATHS.EXPORT_PATIENTS, 'patients_export.csv'),
  previewImportCSV: (formData) => api.upload(API_PATHS.PATIENT_PREVIEW_CSV, formData),
  importCSV: (formData) => api.upload(API_PATHS.PATIENT_IMPORT_CSV, formData),
};

export default patientService;
